/*
Copyright 2017 Travis Ralston

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

export default class PinningUtils {
    /**
     * Determines if the given event may be pinned.
     * @param {MatrixEvent} event The event to check.
     * @return {boolean} True if the event may be pinned, false otherwise.
     */
    static isPinnable(event) {
        if (!event) return false;
        if (event.getType() !== "m.room.message") return false;
        if (event.isRedacted()) return false;

        return true;
    }
}



// WEBPACK FOOTER //
// ../../src/utils/PinningUtils.js